import instanceAxios from '../config/api'
import { Document } from '../types/documentTypes'

const API_URL = '/documents'

export const getDocumentById = async (id: string) => {
  try {
    const response = await instanceAxios.get<Document>(`${API_URL}/${id}`)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch document.')
  }
}
export const getDocumentsByFolder = async (folder: string) => {
  try {
    const response = await instanceAxios.get<Document[]>(`${API_URL}`, {
      params: { folder },
    })
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch documents by folder.')
  }
}
